module.exports = __webpack_public_path__ + "img/qr2.0e6483dc.png";